package com.wintermar.inspection.feature.presentation.inspection.complete_answer

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import com.wintermar.inspection.feature.domain.model.answer.CompleteAnswerModel

class CompleteAnswerState {
    var data by mutableStateOf(CompleteAnswerModel())
}
